import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Send, Globe2, Camera } from "lucide-react";
import { LOGO_URL } from "@/data/blogPosts";

const Footer = () => {
  const quick = [["الرئيسية", "/"], ["من نحن", "/about"], ["الأنشطة", "/activities"], ["المدونة", "/blog"], ["معرض الصور", "/gallery"], ["اتصل بنا", "/contact"]];
  const services = ["تسهيل التواصل مع المؤسسات الصينية", "دعم رجال الأعمال", "تنظيم الفعاليات", "التبادل الثقافي والتعليمي", "دعم الشراكات التجارية"];

  return (
    <footer className="bg-black text-white" dir="rtl">
      {/* @section: footer */}
      <div className="container-pal py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="شعار PalChina" className="h-16 w-16 rounded-full bg-white p-1 object-contain" loading="lazy" />
            <div><h3 className="text-2xl font-black">PalChina.org</h3><p className="text-gold font-bold">جمعية الصداقة الفلسطينية الصينية</p></div>
          </div>
          <p className="mt-5 leading-8 text-white/75">إطار أهلي ومجتمعي لتعزيز الصداقة والتعاون بين الشعبين الفلسطيني والصيني في الثقافة والاقتصاد والتعليم والتواصل المؤسسي.</p>
        </div>
        <div>
          <h4 className="mb-5 text-xl font-black text-gold">روابط سريعة</h4>
          <ul className="space-y-3">{quick.map(([label, path]) => <li key={path}><Link className="text-white/75 hover:text-gold" to={path}>{label}</Link></li>)}</ul>
        </div>
        <div>
          <h4 className="mb-5 text-xl font-black text-gold">خدماتنا</h4>
          <ul className="space-y-3">{services.map((item) => <li key={item} className="text-white/75">{item}</li>)}</ul>
        </div>
        <div>
          <h4 className="mb-5 text-xl font-black text-gold">تواصل معنا</h4>
          <ul className="space-y-4 text-white/75">
            <li className="flex gap-3"><Phone className="text-pal-green" /> <span>00972599520750<br />02-2421153</span></li>
            <li className="flex gap-3"><Mail className="text-pal-green" /> <span>info@palchina.org</span></li>
            <li className="flex gap-3"><MapPin className="text-pal-green" /> <span>رام الله - البيرة، عمارة النجمة، الطابق الثاني، شارع المحكمة</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-pal py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/70">© 2026 PalChina.org - جمعية الصداقة الفلسطينية الصينية. جميع الحقوق محفوظة.</p>
          <div className="flex gap-3"><a className="grid h-10 w-10 place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-black" href="#" aria-label="Website"><Globe2 size={18} /></a><a className="grid h-10 w-10 place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-black" href="#" aria-label="Gallery"><Camera size={18} /></a><a className="grid h-10 w-10 place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-black" href="#" aria-label="Telegram"><Send size={18} /></a></div>
        </div>
        {/* @section: powered-by */}
        <div className="border-t border-white/5 py-3 text-center">
          <p className="text-xs text-white/40">
            Powered By:{" "}
            <a
              href="https://gridsapps.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold/70 hover:text-gold font-semibold transition-colors"
            >
              GridsApps
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
